function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231f20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16.38v16.38H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.78 4.74h-1v1.51h1V4.74zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-2 0h-1v1h1v-1zm-1.38 0h-1v1h.38v-.37h.62v-.63zm0 1.62h-1v1h1v-1zm0 2h-1v1h1v-1zm0 2h-1v1h1v-1zm0 2h-1v1h1v-1zm0 2h-1v1h1v-1zm0 2h-1v1h1v-1zm0 2h-1v1h1v-1zm-.75 1.75H5.4v1h1v-.75h-.75v-.25zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1zm2.13-.87h-1v.87h-.13v1h1v-.87h.13v-1zm0-2h-1v1h1v-1zm0-2h-1v1h1v-1zm0-2h-1v1h1v-1zm0-2h-1v1h1v-1zm0-2h-1v1h1v-1zm0-2h-1v1h1v-1z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.78 21.12"
  }, props), _ref);
};

export default SvgComponent;